import React from 'react';
import Autocomplete from 'react-toolbox/lib/autocomplete';
import Error from 'components/ErrorMessage';// to display error messages on invalid user input
import Button from 'react-toolbox/lib/button';
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import update from 'immutability-helper';
import renderIf from 'render-if';// to use conditional rendering based on values that is provided to component
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import { is, Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work

import styles from './SportsBoard.scss';// to import local scss fle
import theme from './theme.css';

const emptyObject = {};
const offensivePositions = {
  QBDT: 'Quarterback - Duel Threat',
  QBPS: 'Quarterback - Pro Style',
  WR: 'Wide Receiver',
  SR: 'Slot Receiver',
  RB: 'Running Back',
  FB: 'Full Back',
  HB: 'H-Back',
  TE: 'Tight End',
  OG: 'Offensive Guard',
  OT: 'Offensive Tackle',
  C: 'Center',
};

const defensivePositions = {
  DT: 'Defensive Tackle',
  DE: 'Defensive End',
  ML: 'Middle Linebacker',
  OL: 'Outside Linebacker',
  DB: 'Cornerback',
  SS: 'Strong Safety',
  FS: 'Free Safety',

};

const specialTeamsPositions = {
  K: 'Kicker',
  P: 'Punter',
  LS: 'Long Snapper',
};

const t40Suggestions = {};
/* let squatsSuggestions = { 101: '101', 102: '102' }; */
const squatsSuggestions = {};
const benchSuggestions = {};
class SportsBoard extends React.Component {

  static propTypes = {
    next: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    back: PropTypes.func.isRequired,
    profile: PropTypes.instanceOf(Map),
  };
  static defaultProps = {
    next: () => {},
    show: false,
    back: () => {},
    profile: Map(),
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleHeight = this.handleHeight.bind(this);
    this.handleWeight = this.handleWeight.bind(this);
    this.handleQueryChange = this.handleQueryChange.bind(this);
    this.addHeightAndSave = this.addHeightAndSave.bind(this);
    this.addAnotherPreference = this.addAnotherPreference.bind(this);
    this.removeSecondaryPosition = this.removeSecondaryPosition.bind(this);
    this.deleteSecondaryPositionValue = this.deleteSecondaryPositionValue.bind(this);
  }
  state = {
    primary_offensive_position_pref: '',
    secondary_offensive_position_pref: '',
    primary_defensive_position_pref: '',
    secondary_defensive_position_pref: '',
    special_teams: '',
    height: '',
    heightInFeet: '',
    heightInInches: '',
    weight: '',
    sportName: 'FOOTBALL',
    t40: '',
    bench: '',
    squats: '',
    offensivePosition: '',
    defensivePosition: '',
    secondaryPosition: [],
    addSecondaryPosition: false,
    description: '',
    specialTeams: '',
    primaryOffensiveErrorMessage: '',
    primaryDefensiveErrorMessage: '',
    defensiveErrorMessage: '',
    offensiveErrorMessage: '',
    feetErrorMessage: '',
    heightInchesErrorMessage: '',
    heightInFeetErrorMessage: '',
    weightErrorMessage: '',
    sportNameErrorMessage: '',
    t40ErrorMessage: '',
    benchErrorMessage: '',
    squatsErrorMessage: '',
    descriptionErrorMessage: '',
    specialTeamsErrorMessage: '',
    showSecondaryButton: true,
  };

  componentWillReceiveProps(nextProps) {
    const { profile = Map() } = this.props;
    if (nextProps.profile.size > 0 && !is(profile, nextProps.profile)) {
      const saSports = nextProps.profile.get('sports');
      const keys = saSports.keySeq().toArray();
      const sport = saSports.get(keys[0]);
      const combinedHeight = nextProps.profile.get('height');
      const newState = {
        height: nextProps.profile.get('height'),
        heightInFeet: combinedHeight.charAt(0),
        heightInInches: combinedHeight.charAt(2),
        weight: nextProps.profile.get('weight'),
        sportName: keys[0],
        t40: sport.get('t40'),
        bench: sport.get('bench'),
        squats: sport.get('squats'),
        description: sport.get('description'),
        position_pref: sport.get('position_pref'),
      };
      this.setState(newState);
    }
  }


  handleChange = (name, value) => {
    this.setState({ ...this.state, [name]: value });
  };
  handleWeight = (name, value) => {
    this.setState({ ...this.state, [name]: value.target.value });
  };
  removeErrorMessage = (name) => {
    if (name === 'primaryOffensiveErrorMessage' || name === 'primaryDefensiveErrorMessage') {
      this.setState({ primaryOffensiveErrorMessage: '', primaryDefensiveErrorMessage: '' });
    } else {
      this.setState({ ...this.state, [name]: '' });
    }
  };
  handleHeight= (name, value) => {
    if (name === 'heightInFeet') {
      if ((value.target.value <= 7 && value.target.value >= 4) || value.target.value === '') {
        this.setState({ ...this.state, [name]: value.target.value }, () => {
          this.setState({ height: `${this.state.heightInFeet}'${this.state.heightInInches}"` });
        });
      }
    } else if ((value.target.value < 12 && value.target.value >= 0) || value.target.value === '') {
      this.setState({ ...this.state, [name]: value.target.value }, () => {
        this.setState({ height: `${this.state.heightInFeet}'${this.state.heightInInches}"` });
      });
    }
  };
  handleQueryChange(name) {
    this.setState({ ...this.state, [name]: '' });
  }

  addAnotherPreference() {
        let tempData = []; // eslint-disable-line
    tempData = [
      {
        id: 'OFFENSIVE',
        positionValue: '',
      }, {
        id: 'DEFENSIVE',
        positionValue: '',
      },
    ];
    this.setState({ secondaryPosition: tempData,
      showSecondaryButton: false,
      offensiveErrorMessage: '',
      defensiveErrorMessage: '' });
  }

  addValuesToSecondaryPosition(name, value, i) {
    let tempData = [];
    tempData = this.state.secondaryPosition;
    tempData[i].positionValue = value;
    this.setState({ ...this.state, [name]: tempData[i].positionValue });
  }
  deleteSecondaryPositionValue(x) {
    const temp = this.state.secondaryPosition;
    temp[x].positionValue = '';
    this.setState({ secondaryPosition: temp });
    if (x === 0) {
      this.setState({ secondary_offensive_position_pref: '' });
    } else {
      this.setState({ secondary_defensive_position_pref: '' });
    }
  }

  removeSecondaryPosition(i) {
    const temp = this.state.secondaryPosition;
    const index = temp.findIndex(x => x.id === i);
    this.setState({
      secondaryPosition: update(this.state.secondaryPosition, { $splice: [[index, 1]] }),
    }, () => {
      if (this.state.secondaryPosition.length === 0) {
        this.setState({ showSecondaryButton: true });
      }
    });
    if (i === 'OFFENSIVE') {
      this.setState({ secondary_offensive_position_pref: '' });
    } else {
      this.setState({ secondary_defensive_position_pref: '' });
    }
  }
  addHeightAndSave() {
    const updated = {};
        /* Height Validation */
    let validHeightInfeet = false;
    let validHeightInInches = false;

    if (this.state.heightInFeet !== '' && !isNaN(this.state.heightInFeet)) {
      validHeightInfeet = true;
    } else {
      updated.heightInFeetErrorMessage = 'Enter height in feet.';
    }

    if (this.state.heightInInches !== '' && !isNaN(this.state.heightInInches)) {
      validHeightInInches = true;
    } else {
      updated.heightInchesErrorMessage = 'Enter height in inches.';
    }

        /* Height Validation */

        /* weight validation */
    let validWeight = false;
    if (this.state.weight !== '' && this.state.weight >= 120 && this.state.weight <= 350) {
      validWeight = true;
    } else if (!(this.state.weight >= 120 && this.state.weight <= 350) && this.state.weight !== '') {
      updated.weightErrorMessage = 'Enter weight between 120-350 pounds.';
    } else {
      updated.weightErrorMessage = 'Please  add a valid weight.';
    }
        /* weight validation */

      /* Preferred Position validation */
    let validPrimaryPosition = false;
    if (this.state.primary_defensive_position_pref !== '' || this.state.primary_offensive_position_pref !== '') {
      validPrimaryPosition = true;
    } else {
      updated.primaryOffensiveErrorMessage = 'Please select one primary position.';
    }
      /* Preferred Position validation */


      /* T40 validation */
    let validT40 = false;
    if (this.state.t40 !== '' && this.state.t40 >= 4 && this.state.t40 <= 5.5) {
      validT40 = true;
    } else if (!(this.state.t40 >= 4 && this.state.t40 <= 5.5) && this.state.t40 !== '') {
      updated.t40ErrorMessage = 'Enter 40-Yard Dash between 4-5.5 seconds.';
    } else {
      updated.t40ErrorMessage = 'Please add a valid 40-Yard Dash.';
    }
        /* T40 validation */

        /* squats validation */
    let validSquats = false;
    if (this.state.squats !== '' && !isNaN(this.state.squats)) {
      validSquats = true;
    } else {
      updated.squatsErrorMessage = 'Please add a valid Squats.';
    }
        /* squats validation */

        /* Bench validation */
    let validBench = false;
    if (this.state.bench !== '' && !isNaN(this.state.bench)) {
      validBench = true;
    } else {
      updated.benchErrorMessage = 'Please add a valid Bench.';
    }
        /* squats validation */
    let validSecondaryPositionCase = false;
    if (this.state.secondary_defensive_position_pref !== ''
          && this.state.primary_defensive_position_pref === '') {
      validSecondaryPositionCase = false;
      updated.defensiveErrorMessage = 'Please fill primary defensive first.';
    } else if (this.state.primary_defensive_position_pref === '' ||
          this.state.secondary_defensive_position_pref === '') {
      validSecondaryPositionCase = true;
    } else if (this.state.primary_offensive_position_pref !== '' &&
          this.state.secondary_defensive_position_pref !== '' && this.state.primary_defensive_position_pref !== ''
          && this.state.secondary_offensive_position_pref !== '') {
      validSecondaryPositionCase = true;
    }

    let validSamePositionsOffensive = false;
    if (this.state.secondary_offensive_position_pref === '') {
      validSamePositionsOffensive = true;
    } else if (this.state.primary_offensive_position_pref
          === this.state.secondary_offensive_position_pref) {
      validSamePositionsOffensive = false;
      updated.offensiveErrorMessage = 'Primary and secondary positions can not be same.';
    } else if (this.state.secondary_offensive_position_pref !== '') {
      validSamePositionsOffensive = true;
    }

    let validSamePositionsDefensive = false;
    if (this.state.secondary_defensive_position_pref === '') {
      validSamePositionsDefensive = true;
    } else if (this.state.primary_defensive_position_pref
          === this.state.secondary_defensive_position_pref) {
      validSamePositionsDefensive = false;
      updated.defensiveErrorMessage = 'Primary and secondary positions can not be same.';
    } else if (this.state.secondary_defensive_position_pref !== '') {
      validSamePositionsDefensive = true;
    }

    if (validWeight && validPrimaryPosition && validSamePositionsDefensive &&
        validSecondaryPositionCase && validSamePositionsOffensive && validBench && validSquats &&
        validT40 && validHeightInfeet && validHeightInInches) {
      this.setState({ height: `${this.state.heightInFeet}'${this.state.heightInInches}"` });
      this.props.next(this.state);
    } else {
      this.setState(updated);
    }
  }

  render() {
    for (let i = 1; i < 5; i++) { //eslint-disable-line
        for (let x = 0; x <= 10; x++) { //eslint-disable-line
          let listItem = '';
          listItem = ((i * 100) + (x * 10));
          squatsSuggestions[`${listItem}`] = `${listItem}`;
        }
    }
    for (let i = 1; i < 4; i++) { //eslint-disable-line
        for (let x = 0; x <= 10; x++) { //eslint-disable-line
          let listItem = '';
          listItem = ((i * 100) + (x * 10));
          benchSuggestions[`${listItem}`] = `${listItem}`;
        }
    }
    for(let i = 4;i<6;i++){ //eslint-disable-line
        for(let x = 0;x<=10;x++) { //eslint-disable-line
          let listItem = '';
            listItem = `${i + "." + x}`; // eslint-disable-line
          if (x === 10) {
                listItem = `${i+1}.0`; // eslint-disable-line
          }
          if (listItem >= '4.3' && listItem <= '5.5') {
            let left = listItem;
            let right = listItem;
            if (listItem === '4.3') {
              left = listItem;
              right = '4.3 or Lower';
            } else if (listItem === '5.5') {
              left = listItem;
              right = '5.5 or Higher';
            }
            t40Suggestions[`${left}`] = `${right}`;
          }
        }
    }
    const { benchErrorMessage, weightErrorMessage, squatsErrorMessage, t40ErrorMessage,
             primaryDefensiveErrorMessage, defensiveErrorMessage, offensiveErrorMessage,
            heightInchesErrorMessage, heightInFeetErrorMessage, showSecondaryButton,
            secondaryPosition, specialTeamsErrorMessage, primary_offensive_position_pref,
             primaryOffensiveErrorMessage,
            primary_defensive_position_pref,
            special_teams } = this.state;
    const renderIfShow = renderIf(this.props.show);
    const showAddSecondaryButton = renderIf(showSecondaryButton);

    return (
      <div>
        {renderIfShow(<div className={cn('row', styles.sportsBoardContainer)}>
          <div className={cn('col s12', styles.heightAndWidthContainer)}>
            <div className={cn('col s12 m6', styles.heightWidth)}>
              <span>HEIGHT</span>
              <div className={cn('col s12', styles.heightContainer)}>
                <div className={cn('col s6', styles.feetContainer)}>
                  <input
                    className={heightInFeetErrorMessage === '' ? cn('col s12', styles.simpleInput) : cn('col s12', styles.simpleInputError)}
                    type="text"
                    placeholder="Feet"
                    value={this.state.heightInFeet}
                    onFocus={() => this.removeErrorMessage('heightInFeetErrorMessage')}
                    onChange={val => this.handleHeight('heightInFeet', val)}
                  />
                  <Error message={heightInFeetErrorMessage} />
                </div>
                <div className={cn('col s6', styles.inchesContainer)}>
                  <input
                    className={heightInchesErrorMessage === '' ? cn('col s12', styles.simpleInput) : cn('col s12', styles.simpleInputError)}
                    type="text"
                    placeholder="Inches"
                    value={this.state.heightInInches}
                    onFocus={() => this.removeErrorMessage('heightInchesErrorMessage')}
                    onChange={val => this.handleHeight('heightInInches', val)}
                  />
                  <Error message={heightInchesErrorMessage} />
                </div>
              </div>
              {/* <input
                         className={cn('col s12', styles.simpleInput)}
                         type="text"
                         placeholder="example 5'8''"
                         value={this.state.height}
                         onChange={val => this.handleHeightWidth('height', val)}
                         /> */}
            </div>
            <div className={weightErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>WEIGHT</span>
              <input
                className={cn('col s12', styles.simpleInput)}
                value={this.state.weight}
                onChange={val => this.handleWeight('weight', val)}
                onFocus={() => this.removeErrorMessage('weightErrorMessage')}
                placeholder="Pounds"
              />
              <Error message={this.state.weightErrorMessage} />
            </div>
          </div>
          <div className={cn('col s12', styles.fullWidth)}>
            <p className={styles.mySport}>MEASURABLES</p>
            <div className={cn('col s12 m6', styles.mysportContainer)}>
              <span>MY SPORT</span>
              <input
                          /* source={sports} */
                value={this.state.sportName}
              />
            </div>
            <div className={cn('col s12', styles.preferedPositionContainer)}>
              <div className={primaryOffensiveErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                <span>PRIMARY OFFENSIVE POSITION</span>
                <Autocomplete
                  source={offensivePositions}
                  value={primary_offensive_position_pref} // eslint-disable-line
                  onChange={val => this.handleChange('primary_offensive_position_pref', val)}
                  multiple={false}
                  onQueryChange={() => this.handleQueryChange('primary_offensive_position_pref')}
                  direction={'down'}
                  onFocus={() => this.removeErrorMessage('primaryOffensiveErrorMessage')}
                  theme={theme}
                />
                <Error message={primaryOffensiveErrorMessage} />
              </div>
              <div className={primaryDefensiveErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                <span>PRIMARY DEFENSIVE POSITION
                  <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
                </span>
                <Autocomplete
                  source={defensivePositions}
                  value={primary_defensive_position_pref} // eslint-disable-line
                  onChange={val => this.handleChange('primary_defensive_position_pref', val)}
                  multiple={false}
                  onQueryChange={() => this.handleQueryChange('primary_defensive_position_pref')}
                  direction={'down'}
                  onFocus={() => this.removeErrorMessage('primaryDefensiveErrorMessage')}
                  theme={theme}
                />
                <Error message={primaryDefensiveErrorMessage} />
              </div>
              <div className={cn('col s12', styles.removePadding)}>
                {secondaryPosition.map((i, x) => (
                  <div className={cn('col s12 m6', styles.removePadding)}>
                    <div
                      key={i.id} className={(i.id === 'OFFENSIVE' ? offensiveErrorMessage : defensiveErrorMessage) === '' ?
                        cn('col s11 m11', styles.halfWidthWithSpan) : cn('col s11 m11', styles.halfWidthWithSpanError)}
                    >
                      <span>SECONDARY {i.id} POSITION </span>
                      <Autocomplete
                        source={i.id === 'OFFENSIVE' ? offensivePositions : defensivePositions}
                        value={i.positionValue}
                        onChange={val => this.addValuesToSecondaryPosition(i.id === 'OFFENSIVE' ?
                            'secondary_offensive_position_pref' : 'secondary_defensive_position_pref', val, x)}
                        multiple={false}
                        onQueryChange={() => this.deleteSecondaryPositionValue(x)} //eslint-disable-line
                        direction={'down'}
                        onFocus={() => this.removeErrorMessage(i.id === 'OFFENSIVE' ? 'offensiveErrorMessage' : 'defensiveErrorMessage')}
                        theme={theme}
                      />
                      <Error message={i.id === 'OFFENSIVE' ? offensiveErrorMessage : defensiveErrorMessage} />
                    </div>
                    <div className={cn('col s1 m1', styles.removePadding)}>
                      <button
                        className={styles.removeButton}
                        onClick={() => this.removeSecondaryPosition(i.id, i.id === 'OFFENSIVE' ? 'offensiveErrorMessage' : 'defensiveErrorMessage')}
                      >
                        <img src="https://media.dev.myrecruitboard.com/Images/redCross.png" alt="remove" />
                      </button>
                    </div>
                  </div>
                          ))}
              </div>
              {showAddSecondaryButton(
                <div className={cn('col s12 m6', styles.addButtonContainer)}>
                  <button className={styles.addButton} onClick={this.addAnotherPreference}>
                                Add secondary position.
                              </button>
                </div>,
                        )}
              <div className={cn('col s12', styles.removePadding)}>
                <div className={specialTeamsErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
                  <span>SPECIAL TEAMS
                    <span className={styles.optionalTag}>&nbsp;&nbsp;(Optional)</span>
                  </span>
                  <Autocomplete
                    source={specialTeamsPositions}
                    value={special_teams} //eslint-disable-line
                    onChange={val => this.handleChange('special_teams', val)}
                    multiple={false}
                    onQueryChange={() => this.handleQueryChange('special_teams')}
                    direction={'down'}
                    onFocus={() => this.removeErrorMessage('specialTeamsErrorMessage')}
                    theme={theme}
                  />
                  <Error message={specialTeamsErrorMessage} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.fullWidth}>
            <div className={t40ErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>40-YARD DASH</span>
              <Autocomplete
                source={this.state.t40 === '' ? emptyObject : t40Suggestions}
                multiple={false}
                allowCreate
                selectedPosition="below"
                direction="down"
                value={this.state.t40}
                onChange={val => this.handleChange('t40', val)}
                onQueryChange={val => this.handleChange('t40', val)}
                /* onQueryChange={() => this.handleQueryChange('t40')} */
                onFocus={() => this.removeErrorMessage('t40ErrorMessage')}
              />
              <Error message={t40ErrorMessage} />
            </div>
            <div className={squatsErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>SQUATS MAXIMUM</span>
              <Autocomplete
                source={this.state.squats === '' ? emptyObject : squatsSuggestions}
                allowCreate
                multiple={false}
                value={this.state.squats}
                selectedPosition="below"
                direction="down"
                onChange={val => this.handleChange('squats', val)}
                onQueryChange={val => this.handleChange('squats', val)}
                onFocus={() => this.removeErrorMessage('squatsErrorMessage')}
                /* onQueryChange={val => this.generateDropdown(val, 'squatsSuggestions')}
                onFocus={() => this.removeErrorMessage('squatsErrorMessage')} */
              />
              <Error message={squatsErrorMessage} />
            </div>
          </div>
          <div className={cn('col s12', styles.fullWidth)}>
            <div className={benchErrorMessage === '' ? cn('col s12 m6', styles.halfWidthWithSpan) : cn('col s12 m6', styles.halfWidthWithSpanError)}>
              <span>BENCH MAXIMUM</span>
              <Autocomplete
                source={this.state.bench === '' ? emptyObject : benchSuggestions}
                value={this.state.bench}
                multiple={false}
                allowCreate
                selectedPosition="below"
                direction="down"
                onChange={val => this.handleChange('bench', val)}
                onQueryChange={val => this.handleChange('bench', val)}
                /* onQueryChange={val => this.generateDropdown(val, 'benchSuggestions')} */
                onFocus={() => this.removeErrorMessage('benchErrorMessage')}
              />
              <Error message={benchErrorMessage} />
            </div>
          </div>
          <div className={cn('col s12', styles.buttonContainer)}>
            <Button label="< PREVIOUS" className={styles.back} onClick={this.props.back} />
            <Button label="CONTINUE" raised className={styles.continue} onClick={() => this.addHeightAndSave()} />
          </div>
        </div>)}
      </div>

    );
  }
}


export default SportsBoard;



// WEBPACK FOOTER //
// ./src/components/SportsBoard/SportsBoard.js